/** @prettier */
import React, { useEffect, useState } from 'react';

import { useImprovedTranslation } from '@xanadu/ui-shared/hooks';
import showLiveSupport from '@xanadu/ui-shared/utils/showLiveSupport';

import LiveChatIcon from '../../../../images/icons/misc/icon-livechat.svg';

import styles from './LiveChat.module.scss';

/**
 * This component is used to show the live chat button only for desktop devices
 * and only if the Zendesk widget is the classic widget.
 * For the new widget we don't need to show the button as the script
 * already has a button styled and positioned properly.
 */
const LiveChat = () => {
  const { t } = useImprovedTranslation();
  const [isZendeskReady, setIsZendeskReady] = useState(false);

  useEffect(() => {
    const startTime = Date.now();
    const MAX_WAIT_TIME = 10000;

    const checkZendeskWidget = () => {
      const elapsedTime = Date.now() - startTime;

      if (window.zE && window.zE.widget === 'classic') {
        setIsZendeskReady(true);
        return;
      }

      if (window.zE && window.zE.widget && window.zE.widget !== 'classic') {
        setIsZendeskReady(false);
        return;
      }

      if (elapsedTime >= MAX_WAIT_TIME) {
        setIsZendeskReady(false);
        return;
      }

      if (typeof window !== 'undefined' && (!window.zE || !window.zE.widget)) {
        setTimeout(checkZendeskWidget, 500);
      }
    };

    checkZendeskWidget();
  }, []);

  if (!isZendeskReady) {
    return null;
  }

  return (
    <div className={styles.liveChatButton}>
      <button type="button" className={styles.button} onClick={showLiveSupport}>
        <LiveChatIcon className={styles.icon} />
        <span className={styles.text}>{t('Live Chat')}</span>
      </button>
    </div>
  );
};

export default LiveChat;
